import { useEffect, useState } from "react";
import { ArrowUpRight, LineChart } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { brokerGoUrl } from "@/lib/brokers";

// Contextual "open a live account" nudge. Shown on EA/indicator pages and after download.
export default function BrokerCTA({ src = "product", compact = false }) {
  const { user } = useAuth();
  const [brokers, setBrokers] = useState([]);

  useEffect(() => {
    api.get("/brokers").then((r) => setBrokers(r.data || [])).catch(() => setBrokers([]));
  }, []);

  const picks = [...brokers].sort((a, b) => (b.recommended ? 1 : 0) - (a.recommended ? 1 : 0)).slice(0, compact ? 2 : 3);
  if (picks.length === 0) return null;

  return (
    <div className="rounded-xl border border-emerald-500/15 bg-[#0d2416]/50 p-5" data-testid="broker-cta">
      <div className="flex items-center gap-2">
        <LineChart size={16} className="text-lime-300" />
        <p className="overline">Run this on a live account</p>
      </div>
      <p className="mt-2 text-sm text-emerald-100/70">
        These tools run on MT4/MT5. New to live trading, or want a broker I trust? Open an account below.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        {picks.map((b) => (
          <a
            key={b.slug}
            href={brokerGoUrl(b.slug, src, user?.id)}
            target="_blank"
            rel="noopener noreferrer sponsored"
            data-testid={`broker-cta-${b.slug}`}
            className="btn-edge-ghost text-xs"
          >
            {b.recommended ? "★ " : ""}Open with {b.name} <ArrowUpRight size={13} />
          </a>
        ))}
      </div>
      <p className="mt-3 text-[11px] text-emerald-100/40">
        Affiliate links — we may earn a commission if you open an account. It never costs you extra.
      </p>
    </div>
  );
}
